<template>
  <div class="ch-component-warpper">
    <div class="ch-component ch-detail-component">
      <v-container fluid grid-list-lg class="ch-menu-wrapper ch-detail-page">
        <v-layout row wrap>
          <v-flex xs-12>
            <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
              <span class="ch-menu-btn-icon" v-show="navigationDrawer">
                <i class="fas fa-minus fa-fw"></i>
              </span>
              <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
                <i class="fas fa-plus fa-fw"></i>
              </span>
            </button> -->
            <span class="ch-component-title ml-2">DOORLOCK Detail</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-tabs icons class="ch-tabs">
              <v-tabs-bar dark>
                <v-tabs-item
                  v-for="tab in tabs"
                  :key="tab.to"
                  :to="{ name: tab.to }"
                  router
                >
                  <i :class="[ tab.icon ]"></i>
                  <span class="tab-title">{{ tab.title }}</span>
                </v-tabs-item>
              </v-tabs-bar>
            </v-tabs>
            <v-slide-x-transition mode="out-in">
              <router-view></router-view>
            </v-slide-x-transition>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  // import { doorlocksEventBus } from '@/components/admin/doorlocks/doorlocksEventBus';
  import DoorlocksDetailInfo from '@/components/admin/doorlocks/DoorlocksDetailInfo';
  import DoorlocksMobileKey from '@/components/admin/doorlocks/DoorlocksMobileKey';
  import DoorlocksLogs from '@/components/admin/doorlocks/DoorlocksLogs';

  export default {
    data() {
      return {
        id: null,
        doorlock_id: null,
        navigationDrawer: true,
        tabs: [
          {
            title: 'INFORMATION',
            to: 'doorlocksDetailInfo',
            icon: 'fas fa-info-circle',
          },
          // {
          //   title: 'MOBILEKEY LIST',
          //   to: 'doorlockMobileKey',
          //   icon: 'fas fa-list-alt',
          // },
          {
            title: 'LOG LIST',
            to: 'doorlockLogs',
            icon: 'fas fa-list-alt',
          },
        ],
      };
    },
    methods: {
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.doorlock_id = this.$route.params.doorlock_id;

      // doorlocksEventBus.$on('openDialog', () => {
      //   this.dialog = true;
      // });
      navigationEventBus.$on('ondrawerHide', () => {
        window.console.log('ondrawerHide');
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        window.console.log('ondrawerShow');
        this.navigationDrawer = true;
      });
      if (localStorage.getItem('domain_type') === 'root') {
        this.tabs.push({
          title: 'MOBILEKEY LIST',
          to: 'doorlocksMobileKey',
          icon: 'fas fa-list-alt',
        });
      }
      // TODO: Doorlock booking 요구사항 완료시 작업진행
      // if (localStorage.getItem('domain_type') === 'root') {
      //   this.tabs.push({
      //     title: 'BOOKING LIST',
      //     to: 'doorlockBookings',
      //     icon: 'fas fa-list-alt',
      //   });
      // }
    },
    components: {
      DoorlocksDetailInfo, DoorlocksMobileKey, DoorlocksLogs,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/DoorlocksDetail.vue